/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from 'react';
import {BrowserRouter, Route, Routes, Navigate} from 'react-router-dom';

import { UserContext } from './stores/UserStore'

import RedirectTo from './pages/RedirectTo';
import Home from './pages/Home';



const Router = () => {
   
    const { authState } = useContext(UserContext);

    const isAuthenticated = (authState === 'SIGNED_IN');
    const isRefreshToken = (authState === 'REFRESH_TOKEN');
    const isAccessDenied = (authState === 'ACCESS_DENIED');
    const isWaitingAccess = (authState === 'WAITING_FOR_ACCESS');
    const isReload = (authState === 'RELOAD');

    const Private = ({component}) => {   
        return isAuthenticated ? (component) : isReload ? <Navigate to='/redirect/reload' /> : 
                    isRefreshToken ? <Navigate to='/redirect/refresh' /> : 
                        isAccessDenied ? <Navigate to='/redirect/request' /> : 
                            isWaitingAccess ? <Navigate to='/redirect/waiting-access' /> : 
                                <Navigate to='/redirect/logout' />
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/redirect/:to" element={<RedirectTo/>} />        
                <Route path="/" element={ <Private component={<Home/>} />} />
            </Routes>
        </BrowserRouter>
    )
};

export default Router;
